// Simple in-memory cache for deduplicating API requests
const requestCache = new Map<string, Promise<any>>();
const CACHE_DURATION = 3000; // 3 seconds

export function getCachedRequest<T>(
    key: string,
    fetcher: () => Promise<T>,
    cacheDuration: number = CACHE_DURATION
): Promise<T> {
    // Check if we have an ongoing request for this key
    const existingRequest = requestCache.get(key);
    if (existingRequest) {

        return existingRequest;
    }

    // Create new request and cache it

    const newRequest = fetcher()
        .then(result => {
            // Keep the successful result in cache for a bit
            setTimeout(() => {
                requestCache.delete(key);
            }, cacheDuration);
            return result;
        })
        .catch(error => {
            // Remove from cache on error
            requestCache.delete(key);
            throw error;
        });

    requestCache.set(key, newRequest);
    return newRequest;
}

export function clearRequestCache(keyPattern?: string) {
    if (keyPattern) {
        // Clear specific keys matching pattern
        const keys = Array.from(requestCache.keys());
        for (const key of keys) {
            if (key.includes(keyPattern)) {
                requestCache.delete(key);
            }
        }
    } else {
        // Clear all
        requestCache.clear();
    }
} 